<template>
  <main class="app-shell">
    <CalculatorPage />
  </main>
</template>

<script setup lang="ts">
import CalculatorPage from '@/pages/CalculatorPage.vue';
</script>

